export default __webpack_public_path__ + "static/media/green_diago.da3aec5b.png";